/* tslint:disable */
/* eslint-disable */
/* @relayHash 411d3891cb0776d6faafe0606832da85 */

import { ConcreteRequest } from "relay-runtime";
export type AddStoryExpertInput = {
    clientMutationId: string;
    storyID: string;
    userID: string;
};
export type AddExpertMutationVariables = {
    input: AddStoryExpertInput;
};
export type AddExpertMutationResponse = {
    readonly addStoryExpert: {
        readonly story: {
            readonly id: string;
            readonly settings: {
                readonly experts: ReadonlyArray<{
                    readonly id: string;
                    readonly username: string | null;
                    readonly email: string | null;
                }>;
            };
        };
        readonly clientMutationId: string;
    };
};
export type AddExpertMutation = {
    readonly response: AddExpertMutationResponse;
    readonly variables: AddExpertMutationVariables;
};



/*
mutation AddExpertMutation(
  $input: AddStoryExpertInput!
) {
  addStoryExpert(input: $input) {
    story {
      id
      settings {
        experts {
          id
          username
          email
        }
      }
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v2 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "AddStoryExpertPayload",
            "kind": "LinkedField",
            "name": "addStoryExpert",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "story",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorySettings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "experts",
                                    "plural": true,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "username",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "email",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AddExpertMutation",
            "selections": (v2 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AddExpertMutation",
            "selections": (v2 /*: any*/)
        },
        "params": {
            "id": "411d3891cb0776d6faafe0606832da85",
            "metadata": {},
            "name": "AddExpertMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '11c05cbb2776f496eebe85d3990af838';
export default node;
